<template>

  <div id="wrapper" class="">
    <div class="normalheader ">
      <div class="hpanel">
        <div class="panel-body">
          <a class="small-header-action" href="">
            <div class="clip-header">
              <i class="fa fa-arrow-up"></i>
            </div>
          </a>

          <div id="hbreadcrumb" class="pull-right m-t-lg">
            <ol class="hbreadcrumb breadcrumb">
              <li><router-link :to="{name: 'Dashboard'}">Dashboard</router-link></li>
              <li><router-link :to="{name: 'ManageUsers'}">Manage Team</router-link></li>
              <li class="active">
                <span>User</span>
              </li>
            </ol>
          </div>
          <h3 class="font-light m-b-xs">
            Manage User
          </h3>
          <small>Edit Personal information & plans</small>
        </div>
      </div>
    </div>

    <div class="content" v-if="user">

      <div class="row">
        <div class="col-xs-12">
          <div class="hpanel">
            <div class="panel-heading">
              Personal information
            </div>
            <div class="panel-body">
              <personal-information :user="user"></personal-information>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="hpanel">
            <div class="panel-heading">
              Company Information
            </div>
            <div class="panel-body">
              <company-information :company="user.company" :userId="userId"></company-information>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="hpanel">
            <div class="panel-heading">
              Supervisor
            </div>
            <div class="panel-body">
              <supervisor :user="user"></supervisor>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="hpanel">
            <div class="panel-heading">
              Plan quotas
            </div>
            <div class="panel-body">
              <plan-credit :user="user"></plan-credit>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import PersonalInformation from '../../components/user/PersonalInformation'
import CompanyInformation from '../../components/user/CompanyInformation'
import PlanCredit from '../../components/user/PlanCredit'
import Supervisor from '../../components/user/Supervisor'
import Role from '../../components/user/Role'
import Profile from '../../components/user/Profile'

export default {
  components: {
    Supervisor,
    PersonalInformation,
    CompanyInformation,
    PlanCredit,
    Role,
    Profile
  },
  name: 'ManageUser',
  props: [],
  data () {
    return {
      userId: null,
      user: null
    }
  },
  methods: {
    getResources: function () {
      if (this.userId !== null) {
        this.axios.get('/user/' + this.userId + '?relations={profile,planCredit,company,company.country,supervisor,roles,profile,gender}')
          .then((response) => {
            this.user = response.data
          })
          .catch((error) => {
            if (error.response.status === 403) {
              this.$router.replace({name: 'Error403', params: {'0': ''}})
            }
            if (error.response.status === 404) {
              this.$router.replace({name: 'Error404', params: {'0': ''}})
            }
          })
      }
    }
  },
  beforeMount () {
    this.userId = typeof this.$route.params.id !== 'undefined' ? this.$route.params.id : null

    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/manageUsers/User.vue